import { Container } from 'styles/global'
import { Detail } from '../detail'
import { ProjectIntro } from '../projectintro'
import { useLanguage } from 'languages/language'

const CTCatalogue = () => {
  const { texts } = useLanguage()
  return (
    <Container>
      <ProjectIntro project={texts.ctcatalogue} />
      <Detail
        dir="left"
        media={texts.ctcatalogue.imgs[0]}
        text={texts.ctcatalogue.texts[0]}
      />
      <Detail
        dir="right"
        media={texts.ctcatalogue.imgs[1]}
        text={texts.ctcatalogue.texts[1]}
      />
      <Detail
        dir="left"
        media={texts.ctcatalogue.imgs[2]}
        text={texts.ctcatalogue.texts[2]}
      />
    </Container>
  )
}
export default CTCatalogue
